<template>
	<AnalyticsSectionPreviewCard title="Latest errors" class="card-container" linkText="Open task log" :toRouteName="TASK_LOG_ROUTE_NAME">
		<Col class="width-100 height-100">
			<Col v-if="latestErrorsToDisplay.length === 0" class="width-100 height-100 flex-centerize">
				<h3 class="reg">No errors found</h3>
			</Col>
			<AnalyticsLatestErrorItem
				:title="error.title"
				:userId="error.user_id"
				class="latest-error-item"
				:key="`latest-error-${i}`"
				:createdAt="error.created_at"
				v-for="(error, i) in latestErrorsToDisplay"
			/>
		</Col>
	</AnalyticsSectionPreviewCard>
</template>
<script>
import { TASK_LOG_ROUTE_NAME } from '@/router/router.const.js';
import AnalyticsMixin from '@/components/Analytics/mixins/AnalyticsMixin.js';
import AnalyticsLatestErrorItem from '@/components/Analytics/Cards/Items/AnalyticsLatestErrorItem.vue';
import AnalyticsSectionPreviewCard from '@/components/Analytics/Cards/AnalyticsSectionPreviewCard.vue';
export default {
	name: 'AnalyticsLatestErrorsCard',
	mixins: [AnalyticsMixin],
	components: { AnalyticsLatestErrorItem, AnalyticsSectionPreviewCard },
	computed: {
		latestErrorsToDisplay() {
			return this.latestErrors.slice(0, this.maxNumberOfItemsInPreviewCard);
		},
	},
	data() {
		return { TASK_LOG_ROUTE_NAME };
	},
};
</script>
<style scoped lang="scss">
.card-container {
	max-height: 480px;
	min-height: 480px;
	padding: 30px 20px 14px 20px;
}
.latest-error-item {
	max-height: 71px;
}
</style>
